module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Explore our services","services":"Services","dialog":{"title":"Thank you!","description":"Our team will reach out to you soon."}}}')
  delete Component.options._Ctor
}
